import React from "react";
import { Box } from "@mui/material";
import logo from "../../../assets/new_logo.png";
import tokens from "../../theme/tokens";

const { color, font, radius } = tokens;

/**
 * Split auth shell: form on the left, dark product panel on the right.
 * The panel is hidden below 900px and the form fills the viewport.
 */
const AuthLayout = ({ title, subtitle, children, footer }) => (
  <Box sx={{ display: "flex", minHeight: "100vh" }}>
    <Box
      sx={{
        flex: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: color.bg,
        px: 3,
        py: 6,
      }}
    >
      <Box sx={{ width: 360, maxWidth: "100%" }}>
        <Box
          component="img"
          src={logo}
          alt="Hire-Best.ai"
          sx={{ width: 132, display: "block", mb: 3.5 }}
        />
        <Box sx={{ font: `600 22px ${font.sans}`, color: color.text, mb: 0.5 }}>{title}</Box>
        {subtitle && (
          <Box sx={{ font: `400 13px ${font.sans}`, color: color.textMuted, mb: 3 }}>
            {subtitle}
          </Box>
        )}
        {children}
        {footer && (
          <Box
            sx={{
              mt: 2,
              textAlign: "center",
              font: `400 12.5px ${font.sans}`,
              color: color.textMuted,
            }}
          >
            {footer}
          </Box>
        )}
      </Box>
    </Box>

    <Box
      sx={{
        width: 440,
        flex: "none",
        bgcolor: color.dark,
        color: "#fff",
        display: { xs: "none", md: "flex" },
        flexDirection: "column",
        justifyContent: "center",
        p: 6,
      }}
    >
      <Box sx={{ font: `400 12px ${font.mono}`, color: color.textMuted, mb: 2 }}>
        HIRE-BEST.AI CONSOLE
      </Box>
      <Box
        sx={{
          font: `600 26px/1.3 ${font.sans}`,
          letterSpacing: "-.01em",
          mb: 2.75,
        }}
      >
        Every candidate, one table.
        <br />
        Every action, one keystroke.
      </Box>
      <Box
        sx={{
          bgcolor: "rgba(255,255,255,.06)",
          border: "1px solid rgba(255,255,255,.1)",
          borderRadius: `${radius.fileRow + 2}px`,
          p: 2,
          font: `400 12.5px/1.7 ${font.mono}`,
          color: "#B8B8C4",
          whiteSpace: "pre-line",
        }}
      >
        {"⌘K  jump to any job or candidate\nS    schedule screening calls\nI    schedule interviews\n↑    upload resumes"}
      </Box>
    </Box>
  </Box>
);

/** Field label + input styling shared by the auth forms. */
export const authField = {
  "& .MuiOutlinedInput-root": {
    borderRadius: `${radius.control}px`,
    bgcolor: color.surface,
  },
  "& .MuiOutlinedInput-input": { padding: "12px 13px", fontSize: 13.5 },
};

export const AuthLabel = ({ children }) => (
  <Box sx={{ mb: 0.75, font: `500 12px ${font.sans}`, color: color.textSecondary }}>
    {children}
  </Box>
);

export default AuthLayout;
